import React from 'react'


function Footer() {
  return (

      <section className="footer">
        <h3>Hit Me Up on My Email</h3>
        <p>Humairah191002@gmail.com</p>
    </section>
  )
}

export default Footer
